module.exports = __webpack_public_path__ + "static/media/account_icon_level2.2ed6b8c7.svg";